module.exports = __webpack_public_path__ + "img/xaas-period.1cf0999.png";